import PropTypes from "prop-types";
import { Box, Grid, Switch, TextField, Typography } from "@mui/material";
import InputMask from "react-input-mask";

const FormCamposEmpresa = ({ formData, handleChange, buscarCEP, avisoErro }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={11}>
          <TextField
            label="Razão Social"
            name="nome"
            type="text"
            value={formData.nome ?? ""}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid #c4c4c4",
              borderRadius: "4px",
              padding: "10px 12px",
              height: "56px",
              width: "100%",
              position: "relative",
            }}
          >
            <Typography
              sx={{
                position: "absolute",
                top: "-10px",
                left: "10px",
                backgroundColor: "#fff",
                padding: "0 5px",
                fontSize: "12px",
                color: "#6c6c6c",
              }}
            >
              Ativo
            </Typography>
            <Switch
              checked={(formData.status ?? "") === "A"}
              name="status"
              color="warning"
              size="small"
              readOnly={true}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <TextField
            label="CNPJ"
            name="cnpj"
            type="text"
            value={formData.cnpj ?? ""}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            fullWidth
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="IE"
            name="ie"
            type="text"
            value={formData.ie ?? ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="IM"
            name="im"
            type="text"
            value={formData.im ?? ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <InputMask
            mask="99999-999"
            value={formData.cep ?? ""}
            onChange={handleChange}
            onBlur={(e) => {
              const cep = e.target.value.replace(/\D/g, "");
              if (cep.length === 8) {
                buscarCEP(cep);
              }
            }}
          >
            {(inputProps) => (
              <TextField
                {...inputProps}
                label="CEP"
                name="cep"
                type="text"
                required
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextField
            label="Endereço"
            name="endereco"
            type="text"
            value={formData.endereco ?? ""}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            label="Nº"
            name="numero"
            type="text"
            value={formData.numero ?? ""}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            label="Complemento"
            name="complemento"
            type="text"
            value={formData.complemento ?? ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Bairro"
            name="bairro"
            type="text"
            value={formData.bairro ?? ""}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="Cidade"
            name="cidade"
            type="text"
            value={formData.cidade ?? ""}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={1}>
          <TextField
            label="UF"
            name="uf"
            type="text"
            value={formData.uf ?? ""}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>

        {avisoErro && (
          <Typography color="error" variant="caption">
            {avisoErro}
          </Typography>
        )}
      </Grid>
    </Box>
  );
};

FormCamposEmpresa.propTypes = {
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  buscarCEP: PropTypes.func,
  avisoErro: PropTypes.string,
};

export default FormCamposEmpresa;
